import styles from "./styles.module.scss";
import swal from "sweetalert";
import { deleteTranscript } from "../../../../api/transcriptsApi";

function formatDate(input) {
  const date = new Date(input);

  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0"); // January is 0!
  const yyyy = date.getFullYear();
  const HH = String(date.getHours()).padStart(2, "0");
  const MM = String(date.getMinutes()).padStart(2, "0");

  return `${dd}/${mm}/${yyyy} - ${HH}:${MM}`;
}

const TranscriptItem = (props) => {
  const { transcript } = props;

  return (
    <div className={styles.single}>
      <div className={styles.content}>
        <div className={styles.title}>{transcript.title}</div>
        {transcript.tags && transcript.tags.length > 0 && (
          <div className={styles.tags}>
            {transcript.tags.map((tag, index) => (
              <span key={index} className={styles.tag}>
                {tag}
              </span>
            ))}
          </div>
        )}
        <div className={styles.date}>{formatDate(transcript.upload_date)}</div>
        <div
          className={
            transcript.transcript_status === "COMPLETED"
              ? `${styles.status} ${styles.complete}`
              : transcript.transcript_status === "GENERATED"
              ? `${styles.status} ${styles.toReview}`
              : `${styles.status} ${styles.generating}`
          }
        >
          {transcript.transcript_status === "COMPLETED"
            ? "Completed"
            : transcript.transcript_status === "GENERATED"
            ? "In review"
            : "Generating"}
        </div>
      </div>
      <div className={styles.buttons}>
        <a
          href={
            transcript.transcript_status !== "IN PROGRESS"
              ? `/transcripts/${transcript.file_id}`
              : "#"
          }
        >
          <img src="/icons/editing.svg" width={16} height={16} alt="edit" />
        </a>
        <button
          onClick={(e) => {
            e.preventDefault();
            swal({
              title: "ATTENTION! This will remove the transcript completely!",
              text: "This action will delete the transcript and all its data from our system. This action can't be reverted. Are you sure you want to delete the transcript?",
              icon: "warning",
              buttons: ["Cancel", "Delete"],
              dangerMode: true,
            }).then(async (willDelete) => {
              if (willDelete) {
                try {
                  const isSuccess = await deleteTranscript(transcript.file_id);
                  if (isSuccess) {
                    swal(
                      "Transcript deleted",
                      "Your transcript has been deleted successfully!",
                      "success"
                    );
                  }
                } catch (error) {
                  console.error("Error deleting the transcript:", error);
                  swal(
                    "Something went wrong",
                    "Error deleting the transcript. Please try again.",
                    "error"
                  );
                }
              }
            });
          }}
        >
          <img src="/icons/trash-can.png" width={16} height={16} alt="delete" />
        </button>
      </div>
    </div>
  );
};

export default TranscriptItem;
